import QuotationResultsCard from "./quotation-results-card.container";

export default QuotationResultsCard;
